<template>
  <div style="position: relative; overflow: hidden">
    <el-row class="batchOrderList" :class="toggle ? 'up' : 'down'">
      <el-col :span="24" v-for="item in info">
        <div class="price_box red">
          订单金额：<span>¥{{ item.originalAmount }}</span>
        </div>
        <div class="price_box">
          服务信息：<span
            >{{ item.goodsTypeName }} | {{ item.serviceTypeName }}</span
          >
        </div>
        <div class="price_box">
          客户信息：<span
            >{{ item.customerName }} {{ item.customerPhone }}</span
          >
        </div>
        <div class="price_box">
          客户地址：<el-tooltip
            class="item"
            effect="dark"
            :content="item.address"
            placement="bottom"
            popper-class="wuliutooltip"
            :visible-arrow="false"
          >
            <span class="ellipsis">{{ item.address }}</span>
          </el-tooltip>
        </div>
      </el-col>
    </el-row>
    <div class="toggle" @click="toggle = !toggle">
      <a-icon :type="toggle ? 'up' : 'down'" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      toggle: false,
    };
  },

  methods: {},
};
</script>

<style lang='scss'>
.el-dialog {
  .toggle {
    width: 50px;
    height: 10px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 0px 0px 100px 100px;
    position: absolute;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    left: calc(50% - 25px);
    // bottom: -10px;
    bottom: 0;
    z-index: 100;
    &:hover {
      background: #3455d3;
    }
  }
  .batchOrderList {
    background: #fff;
    padding: 20px 18px;
    margin-bottom: 10px;
    // position: relative;
    overflow: hidden;
    &.up {
      height: auto;
    }
    &.down {
      height: 115px;
    }

    .el-col {
      display: flex;
      line-height: 12px;
      margin-top: 20px;
      &:first-child {
        margin-top: 0;
      }
    }
  }
  .price_box {
    font-size: 12px;
    color: #5e6066;
    margin-left: 40px;
    &:first-child {
      margin-left: 0;
    }

    &.red {
      span {
        color: #f75658;
      }
    }
    .ellipsis {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      max-width: 248px;
      display: inline-block;
    }
    span {
      margin-left: 12px;
    }
  }
}
</style>
